/**
 * @generated SignedSource<<bbead6a791886fe7813e1c4b2c5aed9f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProviderRegionStock = "AU" | "BR" | "CA" | "CN" | "EU" | "EU_ES" | "EU_LV" | "JP" | "MX" | "UK" | "US" | "_UNDEFINED";
import { FragmentRefs } from "relay-runtime";
export type productProvider_product$data = {
  readonly conflictingSides: ReadonlyArray<{
    readonly conflicts: ReadonlyArray<string>;
    readonly side: string;
  }>;
  readonly errorMessage: string | null;
  readonly generalInfo: {
    readonly brand: string | null;
    readonly description: string;
    readonly imageUrl: string | null;
    readonly name: string;
    readonly productID: string;
    readonly type: string;
    readonly variantsCount: number;
  };
  readonly isNotRecolor: boolean;
  readonly options: ReadonlyArray<{
    readonly optionID: string;
    readonly title: string;
    readonly type: string;
    readonly values: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }>;
  }>;
  readonly sides: ReadonlyArray<{
    readonly imageUrl: string | null;
    readonly mandatory: boolean;
    readonly side: string;
  }>;
  readonly sidesNames: ReadonlyArray<{
    readonly key: string;
    readonly value: string;
  }>;
  readonly variants: ReadonlyArray<{
    readonly availabilityStatus: ReadonlyArray<{
      readonly region: ProviderRegionStock;
      readonly status: string;
    }>;
    readonly canRotate: boolean;
    readonly colorCode: string | null;
    readonly colorName: string | null;
    readonly imageUrl: string;
    readonly inStock: boolean;
    readonly isColored: boolean;
    readonly name: string;
    readonly price: string;
    readonly productId: number;
    readonly size: string;
    readonly variantID: number;
  }>;
  readonly " $fragmentType": "productProvider_product";
};
export type productProvider_product$key = {
  readonly " $data"?: productProvider_product$data;
  readonly " $fragmentSpreads": FragmentRefs<"productProvider_product">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "side",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "productProvider_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductProviderProductGeneralInfo",
      "kind": "LinkedField",
      "name": "generalInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productID",
          "storageKey": null
        },
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variantsCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductProviderProductOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionID",
          "storageKey": null
        },
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KeyValuePairOfStringAndString",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductProviderProductVariant",
      "kind": "LinkedField",
      "name": "variants",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variantID",
          "storageKey": null
        },
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canRotate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "colorCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "colorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isColored",
          "storageKey": null
        },
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inStock",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailabilityStatus",
          "kind": "LinkedField",
          "name": "availabilityStatus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "region",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyValuePairOfStringAndString",
      "kind": "LinkedField",
      "name": "sidesNames",
      "plural": true,
      "selections": (v3/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductProviderProductSide",
      "kind": "LinkedField",
      "name": "sides",
      "plural": true,
      "selections": [
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mandatory",
          "storageKey": null
        },
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductProviderProductConflictingSides",
      "kind": "LinkedField",
      "name": "conflictingSides",
      "plural": true,
      "selections": [
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conflicts",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNotRecolor",
      "storageKey": null
    }
  ],
  "type": "ProductProviderProduct",
  "abstractKey": null
};
})();

(node as any).hash = "3073d15e1075b6655ed3529afca266bc";

export default node;
